import { motion } from "framer-motion";
import { ArrowRight, Sparkles, Star } from "lucide-react";
import { Button } from "@/components/ui/button";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/efe48500-480e-4db6-8f98-85ad916be57b/images/2e64fba19326e29927e38d303c5f0466980a01a41e0a2f2a19e14e4556de478f.jpeg";

const fade = (d) => ({ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.6, delay: d } });

export const Hero = () => (
  <section className="relative overflow-hidden grain">
    <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-[#F4A261]/30 blur-3xl" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-4 pb-20 pt-12 sm:px-6 lg:grid-cols-12 lg:px-8 lg:pb-28 lg:pt-20">
      <div className="lg:col-span-7">
        <motion.span {...fade(0)} className="inline-flex items-center gap-2 rounded-full border border-[#E05A47]/20 bg-[#E05A47]/10 px-3 py-1 text-xs font-semibold text-[#E05A47]">
          <Sparkles className="h-3.5 w-3.5" /> Agencia digital con inteligencia artificial
        </motion.span>
        <motion.h1 {...fade(0.1)} data-testid="hero-title" className="mt-6 text-4xl font-bold leading-[1.05] tracking-tight text-[#1E1A17] sm:text-5xl lg:text-6xl">
          Más clientas, más ventas.{" "}
          <em className="font-medium text-[#E05A47]">Menos horas</em> peleándote con el marketing.
        </motion.h1>
        <motion.p {...fade(0.2)} className="mt-6 max-w-xl text-base leading-relaxed text-[#6E655F] md:text-lg">
          Ayudamos a emprendedoras y pequeños negocios a vender por internet con redes sociales, anuncios y webs
          potenciadas por IA. Tú te dedicas a tu negocio; nosotras hacemos que te encuentren.
        </motion.p>
        <motion.div {...fade(0.3)} className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Button asChild size="lg" data-testid="hero-try-tools-button" className="h-12 rounded-full bg-[#E05A47] px-7 text-base hover:bg-[#c94a38] active:scale-[0.98]">
            <a href="#herramientas">Probar la IA gratis <ArrowRight className="ml-1 h-4 w-4" /></a>
          </Button>
          <Button asChild size="lg" variant="outline" data-testid="hero-packages-button" className="h-12 rounded-full border-[#1E1A17]/20 bg-transparent px-7 text-base hover:bg-[#1E1A17] hover:text-white">
            <a href="#paquetes">Ver paquetes</a>
          </Button>
        </motion.div>
        <motion.div {...fade(0.4)} className="mt-12 flex flex-wrap gap-x-10 gap-y-4">
          {[["+120", "negocios acompañados"], ["3x", "más mensajes de clientas"], ["24/7", "IA trabajando por ti"]].map(([n, l]) => (
            <div key={l}>
              <div className="font-display text-3xl font-bold text-[#1E1A17]">{n}</div>
              <div className="text-sm text-[#6E655F]">{l}</div>
            </div>
          ))}
        </motion.div>
      </div>
      <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.2 }} className="relative lg:col-span-5">
        <div className="relative overflow-hidden rounded-[2rem] rounded-tl-[6rem] border border-[#E8E1D7] shadow-xl">
          <img src={HERO_IMG} alt="Emprendedora latina sonriendo con su móvil y portátil en su negocio" data-testid="hero-image" className="h-[420px] w-full object-cover object-[center_30%] lg:h-[560px]" />
        </div>
        <div className="floaty absolute -bottom-6 left-4 rounded-2xl border border-[#E8E1D7] bg-white p-4 shadow-lg sm:-left-8">
          <div className="flex gap-0.5 text-[#F4A261]">{[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}</div>
          <p className="mt-1 text-sm font-semibold text-[#1E1A17]">"En un mes llené mi agenda"</p>
          <p className="text-xs text-[#6E655F]">Carmen · Estética en Valencia</p>
        </div>
        <div className="absolute -top-4 right-4 rounded-full bg-[#2A9D8F] px-4 py-2 text-xs font-semibold text-white shadow-lg">
          +48 pedidos esta semana
        </div>
      </motion.div>
    </div>
  </section>
);
